"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitStringByIndex = splitStringByIndex;

function splitStringByIndex(str, idx) {
  if (typeof str !== 'string' || !str || typeof idx !== 'number' || Number.isNaN(idx)) return {
    before: '',
    after: ''
  };
  var before = str.substring(0, idx);
  var after = str.substring(idx);
  return {
    before: before,
    after: after
  };
}